<div class="min-h-screen xl:flex overflow-hidden">
  <div class="shrink-0">
    <app-sidebar></app-sidebar>
    <app-backdrop></app-backdrop>
  </div>
  <!-- (isHovered$ | async) && !(isHovered$ | async)-->
  <div
    class="flex-1 min-w-0 transition-all duration-300 ease-in-out overflow-hidden"
    [ngClass]="{
      'xl:ml-[290px]': (isExpanded$ | async),
      'xl:ml-[90px]': !(isExpanded$ | async),
      'ml-0': (isMobileOpen$ | async),
    }"
  >
    <app-header />

    <div
      class="flex-1 min-w-0 overflow-auto"
      [class]="
        router.url.includes('map/map-studio') || router.url.includes('/copilot')
          ? ''
          : 'p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6'
      "
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
